import { get, index, post, put, cancel } from "src/api/quality-check";
import { findIndex } from "src/assets/scripts/utilities/helpers";

import QualityCheckForm from "src/modules/purchase-order/components/forms/QualityCheckForm.vue";

const getInitialState = () => {
  return {
    qualityChecks: [],
    qualityCheck: {},
  };
};

export const useQualityCheckStore = defineStore("quality-check", () => {
  const { state: qualityCheckFormState, toggle: toggleQualityCheckForm } =
    useDrawer({
      component: QualityCheckForm,
    });

  const state = reactive(getInitialState());

  const setQualityCheck = (updatedQC) => {
    const updateQCIndex = findIndex(state.qualityChecks, updatedQC, "_id");

    const listedQC = state.qualityChecks[updateQCIndex];

    state.qualityCheck = { ...listedQC, ...updatedQC };

    state.qualityChecks[updateQCIndex] = state.qualityCheck;
  };

  const filters = ref({
    po_id: null,
  });

  const { filter, pagination, params } = usePagination(filters);

  const getQualityChecks = async (options = {}) => {
    try {
      if (unref(options)?.filters) {
        filters.value = unref(options)?.filters;
      }

      const response = await index({
        params: params.value,
      });

      state.qualityChecks = response.data?.data?.data;

      pagination.value.rowsNumber = response.data?.data?.count;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const getQualityCheck = async (filter) => {
    try {
      const response = await get(filter);

      state.qualityCheck = response?.data?.data;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postQualityCheck = async (qualityCheck) => {
    const response = await post(qualityCheck);

    return response;
  };

  const putQualityCheck = async (qualityCheck) => {
    const response = await put(qualityCheck);

    return response;
  };

  const cancelQualityCheck = async (payload) => {
    const response = await cancel(payload);

    if (response.status == 200) {
      setQualityCheck(response.data?.data);
    }

    return response;
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    qualityCheckFormState,
    toggleQualityCheckForm,

    filter,
    filters,
    pagination,

    ...toRefs(state),

    setQualityCheck,

    getQualityChecks,
    getQualityCheck,
    postQualityCheck,
    putQualityCheck,

    cancelQualityCheck,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useQualityCheckStore, import.meta.hot),
  );
}
